const modal_route = {
    namespaced: true,
    state: () => ({
        form: '#',
        size: 'md',
        btn_save: false,
        loading: false,
    }),
    mutations: {
        setSize(state, size) {
            state.size = size;
        },
        setForm(state, form) {
            state.form = form;
        },
        btnSave(state, status) {
            state.btn_save = status;
        },
        btnLoading(state, status) {
            state.loading = status;
        }

    },
 
}


export default modal_route;